import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { LiveChatAppAccountCard } from "../../../../components/LiveChatAppAccountCard";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { ReactComponent as ShareIcon } from "./assets/share.svg";
import { ReactComponent as PaintIcon } from "./assets/paint.svg";
import { ReactComponent as SendIcon } from "./assets/send.svg";

export const InstallTabContent: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex animate-fade-in flex-col gap-8 bg-grey-100 p-8 max-lg:gap-4 max-lg:p-4">
      <LiveChatAppAccountCard />
      <CRMInfoSection
        title={t({
          id: "client-support-page.how-to-install",
          defaultMessage: "How to install:",
        })}
        items={[
          {
            title: t({
              id: "client-support-page.set-appearance",
              defaultMessage: "Set Chat Appearance",
            }),
            icon: <PaintIcon />,
            description: t(
              {
                id: "client-support-page.set-appearance-description",
                defaultMessage:
                  "Customise the appearance of chat to match your business style.{br}Define, how your customers will see it 🎨",
              },
              {
                br: <br />,
              }
            ),
          },
          {
            title: t({
              id: "client-support-page.copy-and-share",
              defaultMessage: "Copy & Share",
            }),
            icon: <ShareIcon />,
            description: t(
              {
                id: "client-support-page.copy-and-share-description",
                defaultMessage:
                  "After setting the chat appearance, just copy a link and send it to your Customer.{br}No additional installation needed ⚡",
              },
              {
                br: <br />,
              }
            ),
          },
          {
            title: t({
              id: "client-support-page.see-conversations-in-inbox",
              defaultMessage: "See conversations in Inbox",
            }),
            icon: <SendIcon />,
            description: t(
              {
                id: "client-support-page.see-conversations-in-inbox-description",
                defaultMessage:
                  "All messages from the Live Chat will be represented in the Inbox Module 📥",
              },
              {
                br: <br />,
              }
            ),
          },
        ]}
      />
    </div>
  );
};
